import { GeneratorResult, OperationStatus, selectTyped, takeIf } from '@pressreader/appstore';
import { ArticleCollections } from '@pressreader/social-types';

import { loadArticleCollectionsFinishedActionList } from '../../actions';
import { selectArticleCollectionsByArticleId, selectArticleCollectionsStatusByArticleId } from '../../selectors';

function* waitUntilArticleCollectionsLoaded(articleId: string) {
    const status = yield* selectTyped(selectArticleCollectionsStatusByArticleId, { articleId });
    if (status !== OperationStatus.Pending) {
        return;
    }
    yield* takeIf([...loadArticleCollectionsFinishedActionList], action => action.payload.articleId === articleId);
}

function* getOrWaitForArticleCollections(articleId: string): GeneratorResult<ArticleCollections | undefined> {
    yield* waitUntilArticleCollectionsLoaded(articleId);

    const status = yield* selectTyped(selectArticleCollectionsStatusByArticleId, { articleId });
    const isNonEmptyOrFailedStatus = status !== undefined && status !== OperationStatus.None && status !== OperationStatus.Failed;
    if (isNonEmptyOrFailedStatus) {
        if (status === OperationStatus.Done) {
            const articleCollections = yield* selectTyped(selectArticleCollectionsByArticleId, { articleId });

            return articleCollections ?? undefined;
        }

        return yield* getOrWaitForArticleCollections(articleId);
    }

    return undefined;
}

export { waitUntilArticleCollectionsLoaded, getOrWaitForArticleCollections };
